module.exports = __webpack_public_path__ + "static/media/email.6edcf499.svg";